import React, { FunctionComponent } from "react";

import { useLanguage } from "../../i18n/useLanguage";

export const NationalDescriptor: FunctionComponent = () => {
  const [language] = useLanguage();
  return language === "fr" ? (
    <>
      PNEUS ET
      <br />
      ACCESSOIRES
    </>
  ) : (
    <>
      TIRES AND
      <br />
      ACCESSORIES
    </>
  );
};
